import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class ManageEventLogController extends Controller {
  queryParams = ['page', 'search', 'sort', 'productAreas', 'actors', 'eventTypes'];

  @tracked page = 1;
  @tracked search = '';
  @tracked sort = 'event_timestamp:desc';
  @tracked productAreas: string[] = [];
  @tracked actors: string[] = [];
  @tracked eventTypes: string[] = [];

  @action
  changeSearch(search: string): void {
    this.search = search;
    this.page = 1; // Reset to first page
  }

  @action
  changeSort(sort: string): void {
    this.sort = sort;
    this.page = 1; // Reset to first page
  }

  @action
  changeProductAreas(productAreas: string[]): void {
    this.productAreas = productAreas;
    this.page = 1; // Reset to first page
  }

  @action
  changeActors(actors: string[]): void {
    this.actors = actors;
    this.page = 1; // Reset to first page
  }

  @action
  changeEventTypes(eventTypes: string[]): void {
    this.eventTypes = eventTypes;
    this.page = 1; // Reset to first page
  }

  @action
  changeLocation(_locationId: number | null): void {
    // No-op for local event log
  }
}
